<template>
  <div>
    <b-input-group size="sm">
      <b-form-input
        id="input-location-works"
        size="sm"
        :state="state"
        :disabled="this.$props.isDisabled"
        v-model="query"
        placeholder="Вид работ объекта"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"/>

      <b-input-group-append>
        <b-input-group-text>
          {{ getCurrentRate() }}
        </b-input-group-text>

        <b-input-group-text>
          {{ getCurrentUnit() }}
        </b-input-group-text>

        <b-button size="sm" :disabled="!query || this.$props.isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-input-location-works" v-if="isFocus">
        <b-list-group-item v-for="(item, index) in items" :key="index" @mousedown="onClick(item)" button>
          <div class="">{{ getQueryName(item) }}</div>
        </b-list-group-item>
      </b-list-group>

    </b-input-group>

  </div>
</template>

<script>
import locations from "../../network/locations";
  import unitStore from "../../utilites/unitStore";

export default {
  name: "LocationWorksSelect",
  mixins: [
    locations,
    unitStore
  ],
  props: {
    isDisabled: Boolean,
    state: { type: Boolean, default: null },
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      currentItem: null,
      initialItems: [],
    }
  },
  methods: {
    async configure(id, items) {
      this.items = items;
      this.initialItems = items;
      this.query = "";

      if (id > 0) {
        const result = await this.getLocationWorkById(id);
        if (result.data != null) {
          this.currentItem = result.data;
        }
      } else {
        this.currentItem = null
      }

      if (this.currentItem != null) {
        this.query = this.getQueryName(this.currentItem);
      }

      this.items = await this.getItems(this.query.toLowerCase());
    },
    async onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClear() {
      this.query = '';
      this.currentItem = null;
      this.$emit('onSelect', null);
    },
    onClick(item) {
      this.query = this.getQueryName(item);
      this.currentItem = item;
      this.$emit('onSelect',item);
    },
    getItemListText(item) {
      return item.work_type_name;
    },
    getQueryName(item) {
      return `${item.work_type_name} (${item.rate} ${this.getUnitByCode(item.unit_code).shortName})`;
    },
    async getItems(query) {
      return this.initialItems.filter(function (item) {
        const name = this.getQueryName(item).toLowerCase();
        return name.includes(query);
      }.bind(this));
    },
    getCurrentRate() {
      return this.currentItem && this.currentItem.rate;
    },
    getCurrentUnit() {
      if (this.currentItem == null) {
        return '';
      }
      return this.getUnitByCode(this.currentItem.unit_code).shortName;
    }
  },
  watch: {
    'query': {
      handler: async function () {
        if (this.query != null) {
          const queryLower = this.query.toLowerCase();
          this.items = await this.getItems(queryLower);
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>
/* Autocomplete Select Input */
.autocomplete-input-location-works {
  max-height: 250px;
  margin-top: 31px;
  min-width: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 1000;
}

/* Autocomplete Select Input Group Item */
.autocomplete-input-location-works .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationWorksSelect.vue